import { api } from './api'

/**
 * Tooti+ (B7): the two plans, the caller's entitlement, the free trial
 * (tooti#121), purchase and cancel.
 * Real money crosses the wire as a decimal string (`priceMinor`, minor
 * units — Rial), never a float; this client only ever displays it, never
 * does arithmetic on it beyond the one Rial→Toman divide at render time.
 */

export async function subscriptionPlans() {
  const { data } = await api.get('/subscriptions/plans')
  return data
}

export async function subscriptionStatus() {
  const { data } = await api.get('/subscriptions/status')
  return data
}

/** [plan] is `'standard'` or `'premium'`. */
export async function purchaseSubscription(plan) {
  const { data } = await api.post('/subscriptions/purchase', { plan })
  return data
}

/** Seven days of premium, once per phone number; answers the new status. */
export async function startTrial() {
  const { data } = await api.post('/subscriptions/start-trial', {})
  return data
}

export async function cancelSubscription() {
  const { data } = await api.post('/subscriptions/cancel', {})
  return data
}
